import React from 'react'
import styled from 'styled-components'
import {withState} from 'recompose'
import TranslateText from 'src/text/modal';
import { v4 as uuid } from 'uuid';

const Above = styled.div`
  background: #c6c9d8;
  text-align: center;
  font-size: 14px;
  height: 35px;
  line-height: 35px;
`

const Below = styled.div`
  cursor: pointer;
  background: #e6e8f1;
  color: #0054ff;
  text-align: center;
  font-size: 14px;
  height: 35px;
  line-height: 35px;
  
  &:after {
    content: '';
    ${props => props.open ? '' : 'box-shadow: 0 -18px 69px 11px rgba(255,255,255,0.7);'}
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 35px;
    left: 0
  }  
`

const Container = styled.div`
  position: relative;
`

const ListTable = ({ header, children, style, canOpen = true, open, setOpen }) => (
  <Container style={style}>
    {
      header &&
      <Above>
        {header}
      </Above>
    }
    <div
      style={{
        maxHeight: (!canOpen || open) ? 'initial' : 187,
        overflow: 'hidden',
      }}
    >
      {children}
    </div>
    {canOpen && (open ?
      <TranslateText
        id="catalogue__close-list"
        key={uuid()}
        place="bottom"
        render={text => {
          return (
            <Below onClick={() => setOpen(false)}>
              {text}
            </Below>
          );
        }}
      />
      :
      <TranslateText
        id="catalogue__open-list"
        key={uuid()}
        place="bottom"
        render={text => {
          return (
            <Below onClick={() => setOpen(true)}>
              {text}
            </Below>
          );
        }}
      />)
    }
  </Container>
)

export default withState('open', 'setOpen', false)(ListTable)



// WEBPACK FOOTER //
// ./src/basic/ListTable.js